import { render } from "./CommentPane.vue?vue&type=template&id=3d774bf2&scoped=true"
import script from "./CommentPane.vue?vue&type=script&lang=js"
export * from "./CommentPane.vue?vue&type=script&lang=js"

import "./CommentPane.vue?vue&type=style&index=0&id=3d774bf2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d774bf2"]])

export default __exports__